import { classNames } from '@framework/utils';
import { faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type TabButtonProps = {
  children: React.ReactNode;
  isActive: boolean;
  handleClick: () => void;
};

const TabButton: React.FC<TabButtonProps> = ({ children, isActive, handleClick }: TabButtonProps) => {
  return (
    <button
      className={classNames(
        'flex-1 break-keep border-0 border-b-2 hover:bg-gray-300 focus:outline-none',
        isActive ? 'border-brand text-brand' : 'border-gray-300'
      )}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export type SidebarTabTarget = 'Shared' | 'Personal' | 'Bookmark';

type Props = {
  target: SidebarTabTarget;
  handleShowBookmarks: () => void;
  handleShowShared: () => void;
  handleShowPersonal: () => void;
};

export const SidebarTabContainer: React.FC<Props> = ({
  target,
  handleShowBookmarks,
  handleShowShared,
  handleShowPersonal,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex text-xs">
      <TabButton isActive={target === 'Shared'} handleClick={handleShowShared}>
        <FontAwesomeIcon icon={faUsers} />
        <span className="mr-1" />
        {t('sidebar.tab.shared')}
      </TabButton>
      <TabButton isActive={target === 'Personal'} handleClick={handleShowPersonal}>
        <FontAwesomeIcon icon={faUser} />
        <span className="mr-1" />
        {t('sidebar.tab.personal')}
      </TabButton>
      <TabButton isActive={target === 'Bookmark'} handleClick={handleShowBookmarks}>
        {t('sidebar.tab.bookmark')}
      </TabButton>
    </div>
  );
};
